import { useEventInfo } from './useEventInfo';

/**
 * A React hook that returns the display name of the currently loaded event.
 *
 * This hook internally uses `useEventInfo` to access event metadata and extracts
 * the `eventDisplayName` field. If no event is loaded or the display name is unavailable,
 * it returns an empty string.
 *
 * @returns {string} The display name of the current event, or an empty string if not available.
 */
export function useEventDisplayName(): string {
  const { eventInfo } = useEventInfo();
  return eventInfo?.eventDisplayName ?? '';
}
